// Mock Gurus Data
// Extracted from GuruConnect.tsx and other guru-related components

export interface Guru {
  id: string;
  name: string;
  specialty: string;
  trustScore: number;
  verified: boolean;
  badges: string[];
  rating: number;
  reviewCount: number;
  hourlyRate: number;
  avatar: string;
  bio: string;
  specialties: string[];
  languages: string[];
  availability: string[];
}

export const mockGurus: Guru[] = [
  {
    id: '1',
    name: 'Dr. Sarah Chen',
    specialty: 'Endocrinology',
    trustScore: 98,
    verified: true,
    badges: ['Board-Certified MD', 'Top 10% Satisfaction', 'Diabetes Specialist'],
    rating: 4.9,
    reviewCount: 247,
    hourlyRate: 150,
    avatar: '/avatars/sarah-chen.jpg',
    bio: 'Board-certified endocrinologist specializing in diabetes management and metabolic health.',
    specialties: ['Diabetes', 'Thyroid Disorders', 'Metabolic Syndrome'],
    languages: ['English', 'Mandarin'],
    availability: ['Mon-Fri 9AM-5PM', 'Sat 10AM-2PM']
  },
  {
    id: '2',
    name: 'Coach Mike Rodriguez',
    specialty: 'Fitness & Nutrition',
    trustScore: 95,
    verified: true,
    badges: ['Certified Personal Trainer', 'Registered Dietitian', 'Best Meal-Plan Library'],
    rating: 4.8,
    reviewCount: 189,
    hourlyRate: 75,
    avatar: '/avatars/mike-rodriguez.jpg',
    bio: 'Certified personal trainer and registered dietitian helping clients achieve sustainable health goals.',
    specialties: ['Weight Loss', 'Muscle Building', 'Sports Nutrition'],
    languages: ['English', 'Spanish'],
    availability: ['Mon-Sun 6AM-8PM']
  },
  {
    id: '3',
    name: 'Dr. Emily Watson',
    specialty: 'Mental Health',
    trustScore: 97,
    verified: true,
    badges: ['Licensed Psychologist', 'Trauma Specialist', 'Fastest Response'],
    rating: 4.9,
    reviewCount: 312,
    hourlyRate: 120,
    avatar: '/avatars/emily-watson.jpg',
    bio: 'Licensed clinical psychologist specializing in trauma-informed care and cognitive behavioral therapy.',
    specialties: ['Anxiety', 'Depression', 'PTSD', 'Stress Management'],
    languages: ['English'],
    availability: ['Mon-Fri 10AM-6PM']
  },
  {
    id: '4',
    name: 'Dr. James Wilson',
    specialty: 'Cardiology',
    trustScore: 96,
    verified: true,
    badges: ['Cardiologist', 'Heart Health Expert', 'Preventive Care'],
    rating: 4.8,
    reviewCount: 156,
    hourlyRate: 180,
    avatar: '/avatars/james-wilson.jpg',
    bio: 'Board-certified cardiologist focused on preventive cardiology and heart disease management.',
    specialties: ['Heart Disease', 'Hypertension', 'Cholesterol Management'],
    languages: ['English'],
    availability: ['Mon-Fri 8AM-4PM']
  },
  {
    id: '5',
    name: 'Nutritionist Lisa Park',
    specialty: 'Clinical Nutrition',
    trustScore: 94,
    verified: true,
    badges: ['Registered Dietitian', 'Sports Nutritionist', 'Meal Planning Expert'],
    rating: 4.7,
    reviewCount: 203,
    hourlyRate: 85,
    avatar: '/avatars/lisa-park.jpg',
    bio: 'Registered dietitian specializing in clinical nutrition and personalized meal planning.',
    specialties: ['Clinical Nutrition', 'Sports Nutrition', 'Weight Management'],
    languages: ['English', 'Korean'],
    availability: ['Mon-Sat 9AM-6PM']
  }
]; 